import React, { useContext, useEffect, useState } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import { Button } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import ReplayIcon from "@material-ui/icons/Replay";

import { checkVersion } from "version-rocket";
import packageInfo from "../package.json";
import { IntlProvider } from "react-intl";
import { BrowserRouter } from "react-router-dom";
import Routes from "./Routes";
import ScrollToTop from "utils/ScrollToTop";
import "./assets/base.scss";
import "./App.css";
import CssBaseline from "@material-ui/core/CssBaseline";
import { useSnackbar } from "notistack";
import { GlobalDebug } from "utils/remove-console";
import { messages } from "utils/constants";
import { notify } from "utils/MyFunctions";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";

library.add(far);
library.add(fab);
library.add(fas);

import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

import UserContext from "contexts/userContext";
import { AuthContext } from "utils/AuthContext";
import FeedbackContext from "contexts/feedbackContext";

const useStyles = makeStyles((theme) => {
  return {
    root: {
      ...theme.typography.button,
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(1),
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1000,
      color: "#000",
    },
    typography: {
      fontStyle: "italic",
      fontSize: 24,
      fontWeight: 500,
    },
  };
});

export default function App() {
  const action = (
    <Button
      color="secondary"
      size="small"
      onClick={() => {
        window.location.reload();
      }}
    >
      <ReplayIcon />
    </Button>
  );
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleCloseA = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [version, setVersion] = useState("");
  const { isAuthenticated, login } = useContext(AuthContext);
  const [role, setRole] = useState({});
  const [locale, setLocale] = useState("en");

  const classes = useStyles();
  const [feedback, setFeedback] = useState({
    bdOpen: false,
    snackType: "",
  });

  const [changelog, setChangelog] = useState("");

  const text = "La version " + version + " est disponible";

  const handleClose = () => {
    setFeedback({ ...feedback, ["bdOpen"]: false });
  };
  // const history = useHistory();
  // then add this to the function that is called for re-rendering
  // history.go(0);

  window.onerror = (message, source, lineno, colno, error) => {
    // Log the error details or send them to a logging service
    console.error("Error:", message);
    console.error("Source:", source);
    console.error("Line Number:", lineno);
    console.error("Column Number:", colno);
    console.error("Error Object:", error);

    // Return true to prevent the default browser error handling
    return true;
  };
  // const history = useHistory();
  // then add this to the function that is called for re-rendering
  // history.go(0);

  window.onerror = (message, source, lineno, colno, error) => {
    // Log the error details or send them to a logging service
    console.error("Error:", message);
    console.error("Source:", source);
    console.error("Line Number:", lineno);
    console.error("Column Number:", colno);
    console.error("Error Object:", error);

    // Return true to prevent the default browser error handling
    return true;
  };

  useEffect(() => {
    console.log("chanhgelog changed, changelog : ", changelog);
  }, [changelog]);

  useEffect(() => {
    fetch(`./changelog_${locale}.txt`)
      .then((res) => res.text())
      .then((text) => {
        console.log("text : ", text);
        setChangelog(text);
      });
  }, [locale]);

  useEffect(() => {
    checkVersion(
      {
        localPackageVersion: packageInfo.version,
        originVersionFileUrl: `${location.origin}/version.json`,
        onVersionUpdate: (event) => {
          console.log("version updated");
          console.log("event : ", event);
          setVersion(event.refreshPageVersion);
          handleClick();
        },
        pollingTime: 60 * 60 * 1000,
        // Refer to API for more configuration options
      },
      {
        title: "Mise à jour",
        primaryColor: "#758bfd",
        rocketColor: "#ff8600",
        buttonText: "Cliquez ici pour actualiser la page",
      }
    );

    console.log("app just launched");
    console.log("VERSION FROM PACKAGE JSON : ", packageInfo.version);

    (process.env.NODE_ENV === "production" ||
      process.env.REACT_APP_ENV === "STAGING") &&
      GlobalDebug(false);

    console.log("role : ", role);

    console.log("");

    let user = localStorage.getItem("USER");

    if (user) {
      login();
      console.log("SETTING ROLE AFTER LOGIN, current role : ", role);
      setRole((role) => ({
        ...role,
        user: JSON.parse(localStorage.getItem("USER")),
        company: JSON.parse(localStorage.getItem("company")),
        token: localStorage.getItem("TOKEN_BEARER"),
        shipper: {},
      }));
    }
  }, []);

  useEffect(() => {
    console.log("locale changed, locale : ", locale);
  }, [locale]);

  useEffect(() => {
    if (role && role.user && role.user.company && isAuthenticated) {
      console.log("preferred language");
      setLocale(role.user.company.preferred_language);
    } else {
      console.log("navigator language");
      setLocale(navigator.language.substring(0, 2) === "fr" ? "fr" : "en");
    }
  }, [isAuthenticated]);

  // useEffect(() => {
  //   console.log("feedback changed, new feedback : ", feedback);
  // }, [feedback]);

  return (
    <UserContext.Provider value={{ role, setRole, locale, setLocale }}>
      <IntlProvider locale={locale} messages={messages[locale]}>
        <Snackbar
          open={open}
          onClose={handleCloseA}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          action={action}
        >
          <MuiAlert
            onClose={handleCloseA}
            variant="filled"
            severity="warning"
            action={action}
          >
            <div>
              <strong>
                {locale === "fr"
                  ? "La version " +
                    version +
                    " est disponible, veuillez cliquer pour actualiser votre navigateur"
                  : "Version " +
                    version +
                    " is available, please click to refresh your browser"}
              </strong>
            </div>

            <div style={{ marginTop: 8, paddingLeft: 18 }}>
              <strong>
                {locale === "fr"
                  ? "Principales modifications apportées : "
                  : "Changelog : "}
              </strong>
            </div>
            <div>
              <ul style={{ marginTop: 8, paddingLeft: 18 }}>
                {changelog
                  .split("\n") // découpe en lignes
                  .filter((line) => line.trim() !== "") // ignore les lignes vides
                  .map((line, index) => (
                    <li key={index}>{line}</li>
                  ))}
              </ul>
            </div>
          </MuiAlert>
        </Snackbar>
        <FeedbackContext.Provider
          value={{ feedback, setFeedback, enqueueSnackbar, closeSnackbar }}
        >
          <BrowserRouter basename="/">
            <CssBaseline />
            <Backdrop
              className={classes.backdrop}
              open={feedback.bdOpen}
              onClick={handleClose}
            >
              <CircularProgress color="primary" size={80} />
            </Backdrop>
            <ScrollToTop>
              <Routes />
            </ScrollToTop>
          </BrowserRouter>
        </FeedbackContext.Provider>
      </IntlProvider>
    </UserContext.Provider>
  );
}
